import React, { useRef } from 'react';

const CtModeSelect = ({ value, onChange }) => {
  // Save the initial custom option (if any) in a ref so it doesn’t change on re-render.
  const initialCustomOption = useRef(value !== "C1T1" ? value : null);
  // Always include "C1T1"; add the custom option only if it exists.
  const options = ["C1T1"];
  if (initialCustomOption.current) {
    options.push(initialCustomOption.current);
  }

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{ width: '120px' }} // adjust style as needed for a "small" menu
    >
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};


export default CtModeSelect;
